module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.nome.$error
    }
  }, [_c('label', [_vm._v("Nome*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.nome),
      expression: "model.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    class: {
      'has-danger': _vm.$v.model.dataAplicacao.$error
    }
  }, [_c('label', [_vm._v("Data da Aplicação*")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.config,
      "placeholder": "Selecione",
      "name": "date"
    },
    model: {
      value: (_vm.model.dataAplicacao),
      callback: function($$v) {
        _vm.$set(_vm.model, "dataAplicacao", $$v)
      },
      expression: "model.dataAplicacao"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2",
    class: {
      'has-danger': _vm.$v.model.aplicacao.$error
    }
  }, [_c('label', [_vm._v("Aplicar a cada*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.aplicacao),
      expression: "model.aplicacao"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "number",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.aplicacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "aplicacao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'dropdown-has-error': _vm.$v.model.aplicacaoPeriodo.$error
    }
  }, [_c('label', [_vm._v("Periodo*")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "placeholder": "Selecionar",
      "options": _vm.aplicacaoPeriodo,
      "opt-id": "id",
      "opt-text": "text"
    },
    model: {
      value: (_vm.model.aplicacaoPeriodo),
      callback: function($$v) {
        _vm.$set(_vm.model, "aplicacaoPeriodo", $$v)
      },
      expression: "model.aplicacaoPeriodo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 align-self-center"
  }, [_c('label', [_vm._v("Uso Contínuo?")]), _vm._v(" "), _c('input-toggle', {
    model: {
      value: (_vm.model.usoContinuo),
      callback: function($$v) {
        _vm.$set(_vm.model, "usoContinuo", $$v)
      },
      expression: "model.usoContinuo"
    }
  })], 1), _vm._v(" "), (_vm.model.usoContinuo) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Durante*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.durante),
      expression: "model.durante"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "number",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.durante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "durante", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.model.usoContinuo) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Periodo")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "placeholder": "Selecionar",
      "options": _vm.periodo,
      "opt-id": "id",
      "opt-text": "text"
    },
    model: {
      value: (_vm.model.durantePeriodo),
      callback: function($$v) {
        _vm.$set(_vm.model, "durantePeriodo", $$v)
      },
      expression: "model.durantePeriodo"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.id_via_administracao.$error
    }
  }, [_c('label', [_vm._v("Via de Administração*")]), _vm._v(" "), _c('select-api', {
    attrs: {
      "endpoint": '/viaAdministracao/pesquisa',
      "opt-text": 'nome',
      "select-option": true
    },
    model: {
      value: (_vm.model.id_via_administracao),
      callback: function($$v) {
        _vm.$set(_vm.model, "id_via_administracao", $$v)
      },
      expression: "model.id_via_administracao"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-danger': _vm.$v.model.dose.$error
    }
  }, [_c('label', [_vm._v("Dose*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.dose),
      expression: "model.dose"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.dose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "dose", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('label', [_vm._v("Ações do medicamento")]), _vm._v(" "), _c('dw-multi-select', {
    attrs: {
      "available": _vm.listavailable,
      "requested": _vm.listrequested,
      "opt-text": "nome",
      "disabled": _vm.model.enviado
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-medicine-pet',
        params: {
          id: this.$route.params.id
        }
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])]), _vm._v(" "), (_vm.model.id) ? _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2",
    class: {
      'has-danger': _vm.$v.reminder.lembrete.$error
    }
  }, [_c('label', [_vm._v("Aplicar a cada*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reminder.lembrete),
      expression: "reminder.lembrete"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "number",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.reminder.lembrete)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reminder, "lembrete", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'dropdown-has-error': _vm.$v.reminder.lembretePeriodo.$error
    }
  }, [_c('label', [_vm._v("Periodo*")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "placeholder": "Selecionar",
      "options": _vm.lembrete,
      "opt-id": "id",
      "opt-text": "text",
      "select-option": true
    },
    model: {
      value: (_vm.reminder.lembretePeriodo),
      callback: function($$v) {
        _vm.$set(_vm.reminder, "lembretePeriodo", $$v)
      },
      expression: "reminder.lembretePeriodo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "27px",
      "margin-left": "1%"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveReminder()
      }
    }
  }, [_vm._v("Adicionar")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-md-5"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-md"
  }, [_c('dw-table-head', {
    attrs: {
      "headers": _vm.headers,
      "editable": true
    },
    on: {
      "update": _vm.sort
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.model.lembretes), function(item, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-label": _vm.headers[0].name
      }
    }, [_vm._v("\n                                        " + _vm._s(item.lembrete) + "\n                                        "), (item.lembretePeriodo == 'I') ? _c('span', [_vm._v("Minutos")]) : _vm._e(), _vm._v(" "), (item.lembretePeriodo == 'H') ? _c('span', [_vm._v("Hora(s)")]) : _vm._e(), _vm._v(" "), (item.lembretePeriodo == 'D') ? _c('span', [_vm._v("Dia(s)")]) : _vm._e(), _vm._v(" "), (item.lembretePeriodo == 'S') ? _c('span', [_vm._v("Semana(s)")]) : _vm._e(), _vm._v(" "), (item.lembretePeriodo == 'M') ? _c('span', [_vm._v("Mes(es)")]) : _vm._e(), _vm._v(" "), (item.lembretePeriodo == 'A') ? _c('span', [_vm._v("Ano(s)")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.remove(item.id, index)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  }))], 1)])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fas fa-notes-medical"
  }), _vm._v(" Medicamentos\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fas fa-bell"
  }), _vm._v(" Adicionar Lembrete\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02bd32cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pets/medicine/Form.vue
// module id = 822
// module chunks = 1